import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M19.5 0L12 7.5 4.5 0 0 4.5 7.5 12 0 19.5 4.5 24l7.5-7.5 7.5 7.5 4.5-4.5-7.5-7.5L24 4.5 19.5 0z" fill="#9E5F00" /></svg>;